import { FC } from "react";
import { Stack, Text, useMediaQuery } from "@chakra-ui/react";

import { IScheduleItem } from "../../../../../api/schedule/types.ts";

interface IConfig {
  text: string;
  variant: "gray" | "green" | "red";
  bg: string;
}

interface Props {
  payment: IScheduleItem;
}

export const ScheduleItemTextStatus: FC<Props> = ({ payment }) => {
  const [isSmallScreen] = useMediaQuery("(max-width: 340px)");

  const getConfig = (): IConfig => {
    if (payment.status === "PLANNED" && !payment.isNearestPayment) {
      return { text: "", variant: "gray", bg: "" };
    }

    switch (payment.status) {
      case "PAID": return { text: "Оплачен", variant: "green", bg: "green.25" };
      case "OVERDUE": return { text: "Просрочен", variant: "red", bg: "red.25" };
      case "PLANNED": return { text: "Ожидаем платеж", variant: "gray", bg: "gray.50" };
      default: return { text: "", variant: "gray", bg: "" };
    }
  };

  const { text, variant, bg } = getConfig();

  return (
    <Stack h="24px" w={isSmallScreen ? "70px" : "unset"} bg={bg} px="8px" borderRadius="20px" justifyContent="center">
      <Text variant={variant} fontSize="10px" lineHeight="10px" textAlign="center">
        {text}
      </Text>
    </Stack>
  );
};
